"use strict";

import React from "react";

import Period from "./Period.jsx";
import Table from "./Table.jsx";
import MultiTable from "./MultiTable.jsx";
import Matrix from "./Matrix.jsx";
import StatusSelector from "./StatusSelector.jsx";
import Status from "./Status.jsx";
import FormattedContent from "./FormattedContent.jsx";
import ProcessView from "./ProcessView.jsx";
import RichTextEditor from "./RichTextEditor.jsx";

let width = 280;

let height = 30;
let inputStyle = {
  paddingLeft: 5,
  paddingRight: 5,
  paddingBottom: 5,
  fontFamily: "Lato, Arial, Verdana, Geneva, sans-serif",
  backgroundColor: "#ffffff",
  border: "1px solid #C1C1C1",
  borderRadius: 0,
  fontSize: "12pt",
};

class ExpandableTextArea extends React.Component {
  constructor(props) {
    super(props);
    this.state = { height: height * this.props.height };
  }

  componentDidMount() {
    this.calculateSize();
  }

  calculateSize() {
    this._textarea.style.height = "auto";
    if (this._textarea.scrollHeight > height * this.props.height) {
      this._textarea.style.height = this._textarea.scrollHeight + 2 + "px";
    } else {
      this._textarea.style.height = height * this.props.height + "px";
    }
  }

  expand(event) {
    this.calculateSize();
    if (this.props.onChange !== undefined) {
      this.props.onChange(event);
    }
  }

  render() {
    return this.props.expand ? (
      <textArea
        ref={(ref) => (this._textarea = ref)}
        onChange={this.expand.bind(this)}
        name={this.props.name}
        defaultValue={this.props.value}
        style={Object.assign({}, inputStyle, {
          height: this.state.height,
          width: "100%",
        })}
        placeholder={this.props.help}
      />
    ) : (
      <textArea
        onChange={this.props.onChange}
        name={this.props.name}
        defaultValue={this.props.value}
        style={Object.assign({}, inputStyle, {
          height: height * this.props.height,
          width: "100%",
        })}
        placeholder={this.props.help}
      />
    );
  }
}

class TextField extends React.Component {
  render() {
    return this.props.height !== undefined ? (
      this.props.plainText === true ? (
        <ExpandableTextArea {...this.props} expand={true} />
      ) : (
        <RichTextEditor style={inputStyle} {...this.props} />
      )
    ) : (
      <input
        onChange={this.props.onChange}
        disabled={this.props.disabled}
        className="input"
        name={this.props.name}
        defaultValue={this.props.controlled ? undefined : this.props.value}
        style={Object.assign({}, inputStyle, { height: height })}
        placeholder={this.props.help}
        readOnly={this.props.readonly}
        autoComplete={
          this.props.autoComplete !== undefined ? this.props.autoComplete : "on"
        }
        value={
          this.props.controlled
            ? this.props.value
              ? this.props.value
              : ""
            : undefined
        }
      />
    );
  }
}

class InputField extends React.Component {
  render() {
    return this.props.type === "process" ? (
      <ProcessView {...this.props} />
    ) : this.props.type === "table" ? (
      <Table {...this.props} />
    ) : this.props.type === "period" ? (
      <Period {...this.props} />
    ) : this.props.options === undefined ? (
      <TextField {...this.props} />
    ) : (
      <select
        onChange={this.props.onChange}
        className="input"
        style={Object.assign({}, inputStyle, { height: height })}
        name={this.props.name}
        defaultValue={
          this.props.value !== undefined && !this.props.controlled
            ? this.props.value
            : this.props.controlled
            ? undefined
            : this.props.defaultValue
        }
        value={
          this.props.controlled
            ? this.props.value !== undefined
              ? this.props.value
              : this.props.defaultValue
            : undefined
        }
        disabled={this.props.disabled}
      >
        {this.props.options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.text !== undefined
              ? option.text
              : ".(" + option.value + ")"}
          </option>
        ))}
      </select>
    );
  }
}

class AddEntry extends React.Component {
  showForm(event) {
    event.preventDefault();
    if (this.props.addEntry.handler !== undefined) {
      this.props.addEntry.handler({
        field: this.props.name,
        item: Object.assign({}, this.props.item, {
          _progress:
            this.props.addEntry !== undefined &&
            this.props.addEntry.formDefinition !== undefined &&
            this.props.addEntry.formDefinition.length > 0
              ? this.props.addEntry.formDefinition.slice(-1)[0].name
              : undefined,
        }),
        form: this.props.addEntry.formDefinition,
        type: this.props.type,
      });
    }
  }

  render() {
    let disabled =
      this.props._disableOption !== undefined &&
      this.props._disableOption.includes("addEntry");
    if (
      this.props.addEntry !== undefined &&
      this.props.addEntry !== null &&
      this.props.type === "table"
    ) {
      let title =
        this.props.addEntry.title !== undefined
          ? this.props.addEntry.title
          : ".(options.addEntry)";
      return disabled ? null : (
        <div
          style={{
            cursor: "pointer",
            float: "right",
            textDecoration: "underline",
          }}
          onClick={this.showForm.bind(this)}
        >
          {title}
        </div>
      );
    } else {
      return null;
    }
  }
}

class OrdinaryField extends React.Component {
  constructor(props) {
    super(props);
    this.state = { showHelp: false, showPrevious: false };
  }

  toggleHelp(event) {
    event.preventDefault();
    this.setState({ showHelp: !this.state.showHelp });
  }

  togglePrevious(event) {
    event.preventDefault();
    this.setState({ showPrevious: !this.state.showPrevious });
  }

  onEditEntry(item) {
    if (
      this.props.onEditEntry !== undefined &&
      this.props.options !== undefined &&
      this.props.options.edit !== undefined
    ) {
      this.props.onEditEntry({
        field: this.props.name,
        form: this.props.options.edit.formDefinition,
        item: item,
        type: this.props.type,
      });
    }
  }

  render() {
    let className =
      this.props.height !== undefined ||
      this.props.type === "period" ||
      this.props.type === "table" ||
      this.props.type === "process"
        ? "textarea"
        : "field";
    let title =
      this.props.title !== undefined
        ? this.props.title
        : ".(" + this.props.name + ")";
    let excluded =
      this.props.excludedFor !== undefined
        ? this.props.excludedFor.filter(
            (type) => type === this.props.displayType,
          ).length > 0
        : undefined;
    let included =
      this.props.includedFor !== undefined
        ? this.props.includedFor.filter(
            (type) => type === this.props.displayType,
          ).length > 0
        : undefined;
    let show =
      (excluded === undefined && included === undefined) ||
      (included === undefined && !excluded) ||
      (included && excluded === undefined)
        ? true
        : false;
    return show ? (
      <div className={className} style={{ marginBottom: 20 }}>
        <AddEntry {...this.props} />
        <div style={{ fontWeight: "bold", fontSize: "14pt" }}>
          <div style={{ marginBottom: 5 }}>
            {title}{" "}
            {this.props.optional !== undefined ? null : (
              <span style={{ color: "red" }}>*</span>
            )}
            {this.props.showFlag === true ? (
              <img
                style={{
                  paddingLeft: 10,
                  verticalAlign: "bottom",
                  paddingTop: 3,
                }}
                src="/images/Flag_FinishGrey_22x16.gif"
              />
            ) : null}
            {this.props.includeStatus ? (
              <div
                style={{
                  display: "inline-block",
                  fontWeight: "normal",
                  paddingLeft: 20,
                  height: 18,
                }}
              >
                <StatusSelector
                  {...this.props}
                  name={this.props.name}
                  value={this.props.statusValue}
                  style={{
                    top: -1,
                    padding: 10,
                    left: -10,
                    item: { padding: 5 },
                  }}
                />
              </div>
            ) : null}
            {this.props.help !== undefined ? (
              <span
                style={{
                  paddingLeft: 10,
                  fontWeight: "normal",
                  cursor: "pointer",
                }}
                onClick={this.toggleHelp.bind(this)}
              >
                <img src="/icons/help.png" />
              </span>
            ) : null}
            {(this.props.previousValue !== undefined &&
              this.props.previousValue !== null &&
              this.props.previousValue.trim().length > 0) ||
            (this.props.previousStatusValue !== undefined &&
              this.props.previousStatusValue !== null &&
              this.props.previousStatusValue.trim().length > 0) ? (
              <div
                onClick={this.togglePrevious.bind(this)}
                style={{
                  float: "right",
                  fontSize: "12pt",
                  textDecoration: "underline",
                  fontWeight: "normal",
                  cursor: "pointer",
                }}
              >
                {this.state.showPrevious ? "Hide " : "Show "}previous text
              </div>
            ) : null}
          </div>
        </div>
        {this.state.showHelp ? (
          <div
            style={{
              paddingLeft: 10,
              paddingTop: 5,
              paddingBottom: 5,
              fontStyle: "italic",
            }}
          >
            <FormattedContent value={this.props.help} />
          </div>
        ) : null}
        {this.state.showPrevious ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              paddingLeft: 10,
              paddingTop: 5,
              paddingBottom: 5,
            }}
          >
            <div style={{ paddingRight: 10 }}>
              <Status value={this.props.previousStatusValue} />
            </div>
            <div>
              <FormattedContent value={this.props.previousValue} />
            </div>
          </div>
        ) : null}
        <InputField
          {...this.props}
          help={this.props.description}
          onEditEntry={
            this.props.onEditEntry !== undefined
              ? this.onEditEntry.bind(this)
              : undefined
          }
        />
      </div>
    ) : null;
  }
}

export default class Field extends React.Component {
  render() {
    return this.props.type === "matrix" ? (
      <Matrix {...this.props} />
    ) : this.props.type === "multiTable" ? (
      <MultiTable {...this.props} />
    ) : (
      <OrdinaryField {...this.props} />
    );
  }
}



// WEBPACK FOOTER //
// ./views/components/Field3.jsx